import { render, staticRenderFns } from "./DefectDojo.vue?vue&type=template&id=30d801cc&"
import script from "./DefectDojo.vue?vue&type=script&lang=js&"
export * from "./DefectDojo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d801cc')) {
      api.createRecord('30d801cc', component.options)
    } else {
      api.reload('30d801cc', component.options)
    }
    module.hot.accept("./DefectDojo.vue?vue&type=template&id=30d801cc&", function () {
      api.rerender('30d801cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/integrations/DefectDojo.vue"
export default component.exports